import { render } from "./MedicationsAdd.vue?vue&type=template&id=671f0cff"
import script from "./MedicationsAdd.vue?vue&type=script&lang=js"
export * from "./MedicationsAdd.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sendOuts/MedicationsAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "671f0cff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('671f0cff', __exports__)) {
    console.log('reload')
    api.reload('671f0cff', __exports__)
  }
  
  module.hot.accept("./MedicationsAdd.vue?vue&type=template&id=671f0cff", () => {
    console.log('re-render')
    api.rerender('671f0cff', render)
  })

}


export default __exports__